import { move } from 'ramda';
import { useDispatch } from 'react-redux';

import { openUploadModal } from 'components/Layouts/Form/FormBuilder/Content/AddNewContent/uploadModal';
import useAssetsPermissions from 'hooks/useAssetsPermissions';
import useValidationSchema from 'hooks/useValidationSchema';
import { confirmAlert } from 'utils/alert';
import { updateArrayById } from 'utils/immutableFunctions';

import validationSchema from './validationSchema';

export function useResources({ page }) {
  const dispatch = useDispatch();
  const { withAssetSettings } = useAssetsPermissions();

  const onDelete = (type) => (asset, form) => {
    confirmAlert({
      title: 'Are you sure you want to delete this attached file?',
      confirmButtonText: 'Delete',
      onConfirm: () => {
        const formType = getFormType(type);
        const files = [...form?.getState()?.values[formType]];
        const index = files.findIndex((f) => f.id === asset.id);

        if (index > -1) {
          files.splice(index, 1);
        }

        form.change(formType, files);
      },
    });
  };

  const onAfterEdited = (type) => (asset, form) => {
    const formType = getFormType(type);
    const files = [...form?.getState()?.values[formType]];
    const index = files.findIndex((f) => f.id === asset.id);

    if (index > -1) {
      form.change(
        formType,
        updateArrayById(files, asset.id, () => asset),
      );
    }
  };

  const onReorder = (form) => (oldIndex, newIndex) => {
    const files = [...(form?.getState()?.values?.media || [])];

    form.change('media', move(oldIndex, newIndex, files));
  };

  const openModal = async (type, form) => {
    const formType = getFormType(type);

    const assets = await openUploadModal(dispatch, {
      withAssetSettings,
      type,
      suggested: page,
      selected: [...(form?.getState()?.values[formType] || [])],
      isCenterOfImageEnabled: false,
      isSortingEnabled: true,
      defaults: {
        name: page.name,
        tags: page.tags,
      },
    });

    if (assets === null) {
      return;
    }

    form.change(formType, assets);
  };

  const validate = useValidationSchema(validationSchema);

  return {
    onDelete,
    onReorder,
    openModal,
    onAfterEdited,
    data: page,
    validate,
  };
}

function getFormType(type) {
  return type === 'document' ? 'documents' : 'media';
}
